import { ofType } from 'redux-observable';
import { exhaustMap } from 'rxjs/operators';

import {
    createPerpayPlusSoloEnrollmentInMarketplacePHO as createPerpayPlusSoloEnrollmentInMarketplacePHOAction,
    createPerpayPlusSoloEnrollmentInMarketplacePHOError,
    createPerpayPlusSoloEnrollmentInMarketplacePHOSuccess,
    createPerpayPlusSoloFeatureEnrollment as createPerpayPlusSoloFeatureEnrollmentAction,
    createPerpayPlusSoloFeatureEnrollmentSuccess,
    createPerpayPlusSoloFeatureEnrollmentError,
} from '@perpay-web/fintech/actions/entities/perpayPlusSolo';
import { routeToLocation } from '@perpay-web/fintech/actions/router';
import { PERPAY_PLUS_SOLO } from '@perpay-web/fintech/constants/featureTypes';
import { paths } from '@perpay-web/fintech/props/appPaths';
import { dispatchObservable } from '@perpay-web/observable/dispatchObservable';

export const createPerpayPlusSoloEnrollmentInMarketplacePHOEpic = (
    action$,
    state$,
) =>
    action$.pipe(
        ofType(createPerpayPlusSoloEnrollmentInMarketplacePHOAction().type),
        exhaustMap(() =>
            dispatchObservable({
                action$,
                state$,
                initialDispatch: () => [
                    createPerpayPlusSoloFeatureEnrollmentAction({
                        feature: PERPAY_PLUS_SOLO,
                    }),
                ],
                waitFor: [createPerpayPlusSoloFeatureEnrollmentSuccess().type],
                waitForDispatch: () => [
                    createPerpayPlusSoloEnrollmentInMarketplacePHOSuccess(),
                    routeToLocation({
                        path: paths.perpayPlusSoloApplication.path,
                        replace: true,
                    }),
                ],
                errors: [createPerpayPlusSoloFeatureEnrollmentError().type],
                errorDispatch: (error) =>
                    createPerpayPlusSoloEnrollmentInMarketplacePHOError(error),
            }),
        ),
    );
